import React from 'react'
import { FaSpaceShuttle, FaChalkboard, FaAccessibleIcon } from 'react-icons/fa'

const Features = () => (
    <section className="relative z-20 bg-gradient" id="features">
        <div className="container flex flex-col justify-between py-12 lg:flex-row">
            <div className="flex-1 px-0 py-2 lg:px-1 lg:py-0">
                <h1 className="text-3xl font-bold"><FaSpaceShuttle className="inline"/> Fast Mockups</h1>
                <p className="py-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sollicitudin nisl a rutrum ultrices. Sed.</p>
            </div>
            <div className="flex-1 px-0 py-2 lg:px-1 lg:py-0">
                <h1 className="text-3xl font-bold"><FaChalkboard className="inline"/> Clear brand guidelines</h1>
                <p className="py-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sollicitudin nisl a rutrum ultrices. Sed.</p>
            </div>
            <div className="flex-1 px-0 py-2 lg:px-1 lg:py-0">
                <h1 className="text-3xl font-bold"><FaAccessibleIcon className="inline"/> Accessible designs</h1>
                <p className="py-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sollicitudin nisl a rutrum ultrices. Sed.</p>
            </div>
        </div>
    </section>
)

export default Features